import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, ShieldCheck, Target, Users } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function Firearms() {
  useDocumentMeta('Firearms Store in Lake Benton, Minnesota | Kjergaard Sports', 'Browse approximately 5,000 new and used firearms on hand at Kjergaard Sports in Lake Benton, Minnesota. Options for hunting, sport shooting, CCW, and collectors.');
  const categories = ['Hunting firearms', 'Sport shooting', 'CCW customers', 'Collectors', 'Trap and skeet', 'Waterfowl', 'Upland', 'Varmints', 'Big game', 'Shotguns, rifles, handguns, and more'];
  return <div data-id="element-339">
      <PageHero title="Firearms Store in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/h2HHsk76CJxRY2pmsyL8mj/firearms-wall.jpg" alt="Firearms selection at Kjergaard Sports" data-id="element-340" />

      <section className="py-20 bg-brand-offwhite" data-id="element-341">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-343">
            <div data-id="element-344">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-345">
                Approximately 5,000 Guns on Hand
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-346">
                Kjergaard Sports is known across the region for our sheer volume
                and variety of firearms. We carry an enormous selection of new
                and used guns, ensuring that whether you are a first-time buyer
                or a seasoned collector, you'll find options worth exploring.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-347">
                We believe in the value of browsing in person. When you visit
                our store, you can handle the equipment, compare models
                side-by-side, and get practical guidance from staff who
                understand the products.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-348">
                <h3 className="font-serif text-xl mb-4" data-id="element-349">
                  Our Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-350">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-351">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-352" />
                      <span className="text-brand-charcoal/90" data-id="element-353">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div data-id="element-354">
              <img src="https://cdn.magicpatterns.com/uploads/1WmymfCRjNVxeWfAjjuCCR/firearms-cases.jpg" alt="Firearms display cases at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-355" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-356">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-357">
              <Target className="w-10 h-10 text-brand-hunter mb-4" data-id="element-358" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-359">
                Built for Hunters First
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-360">
                Our inventory is heavily focused on the needs of hunters. From
                upland bird shotguns to precision big game rifles, we stock the
                tools required for every season.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-361">
              <Users className="w-10 h-10 text-brand-hunter mb-4" data-id="element-362" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-363">
                Sport Shooters & CCW
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-364">
                We carry a deep selection of handguns for personal defense and
                concealed carry, as well as platforms built for trap, skeet, and
                competitive shooting.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-365">
              <ShieldCheck className="w-10 h-10 text-brand-hunter mb-4" data-id="element-366" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-367">
                New and Used Firearms
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-368">
                Our inventory includes both brand new models from major
                manufacturers and a constantly rotating selection of quality
                used firearms.
              </p>
            </div>
          </div>

          <div className="relative rounded-sm overflow-hidden shadow-lg" data-id="element-369">
            <img src="https://cdn.magicpatterns.com/uploads/4PEc13YMi3QHpCzosrhrkQ/store-interior-firearms-wide.jpg" alt="Wide view of the firearms selection at Kjergaard Sports" className="w-full h-[400px] object-cover" data-id="element-370" />
            <div className="absolute inset-0 bg-brand-charcoal/40 flex items-center justify-center p-8" data-id="element-371">
              <div className="bg-brand-offwhite/95 backdrop-blur-sm p-8 max-w-2xl text-center rounded-sm" data-id="element-372">
                <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-373">
                  Plan Your Visit or Call Ahead
                </h3>
                <p className="text-brand-charcoal/80 mb-0" data-id="element-374">
                  Because our inventory is so large and changes frequently, we
                  do not maintain an online catalog. Please call the store to
                  check availability on specific models, or make the drive to
                  browse the selection in person.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-375" />
    </div>;
}